import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";
import App from "./App";
import theme from "./theme";
import reportWebVitals from "./reportWebVitals";
import { loadRuntimeConfig } from "./api/runtimeConfig";
import { ensureSignedIn } from "./api/auth";

const rootEl = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootEl);

function render() {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App />
      </ThemeProvider>
    </React.StrictMode>
  );
}

// Load runtime config (settings.json) before rendering. When deployed
// (settings present) require a signed-in Cognito user via the Hosted UI; in
// local dev (no settings) render immediately against mock data.
loadRuntimeConfig()
  .then(async (settings) => {
    if (settings) {
      await ensureSignedIn(settings);
    }
  })
  .catch(() => {
    /* fall through to render; the app degrades to mock mode */
  })
  .finally(render);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log)).
reportWebVitals();
